import React from 'react';
import { useMediaQuery } from 'react-responsive';
import EmailHostingContent from './EmailHostingContent';

const Desktop = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: 768 });
  return isDesktop ? children : null;
};

const DesktopResponsive = ({ history }) => (
  <Desktop>
    <EmailHostingContent history={history} />
  </Desktop>
);

export default DesktopResponsive;
